type AddressType = Record<'Arrival' | 'Departure', 1 | 2>

export const ADDRESS_TYPE: AddressType = {
  Departure: 1,
  Arrival: 2,
}

type AddressRadioType = Record<'SELECT' | 'CUSTOM', 'select' | 'custom'>

export const ADDRESS_RADI_TYPE: AddressRadioType = {
  SELECT: 'select',
  CUSTOM: 'custom',
}
